import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div>
      <div className="main" id="skills">
        <div className="skills-header-div">
          <Fade bottom duration={2000} distance="20px">
            {/* <h1 className="skills-header" style={{ color: theme.text }}> */}
            <h1>My technical experience:</h1>
            {/* </h1> */}
          </Fade>
        </div>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
